import { css } from '@emotion/react';
import { margins } from '@spotnana/blocks/src/utils';

export const days_changed_indicator = css`
  ${margins.xl.point25}
`;

export const strike_through = css`
  text-decoration: line-through;
`;

export const date_container = css`
  display: flex;
  flex-direction: column;
  ${margins.yb.half}
`;

export const date_label_container = css`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;
export const date_label = css`
  display: flex;
`;
